<div class="light-font mt-2">
  <mdb-breadcrumb customClass="primary-color white-text">
    <ng-container *ngFor="let ruta of rutas; let i = index">
      <mdb-breadcrumb-item *ngIf="i < (rutas.length - 1)" routerLink="{{ruta.path}}" >{{ruta.texto}}</mdb-breadcrumb-item>
      <mdb-breadcrumb-item *ngIf="i === (rutas.length - 1)" class="nav-bread-active" >{{ruta.texto}}</mdb-breadcrumb-item>
    </ng-container>
  </mdb-breadcrumb>
</div>